import {
  body,
  icon
} from './style'
import { SettingButtonTypes } from "types"
import { Icon } from 'icons/Icon'

export const SettingButton = ({onClick}: SettingButtonTypes) => {
  return (
    <div className={body} onClick={() => onClick()}>
      <Icon className={icon} name="Setting" size={22} />
    </div>
  );
}

